import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../common/Forms/SingleSelect';

const SingleFormSelect = ({ options, name, initialValue }) => {
  const [selectedOption, setSelectedOption] = useState(initialValue);

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  return (
    <Fragment>
      <input name={name}
             value={selectedOption && selectedOption.value}
             hidden/>
      <SingleSelect
        handleChange={handleChange}
        options={options}
        selectedValue={selectedOption}
      />
    </Fragment>
  );
};

SingleFormSelect.propTypes = {
  options: PropTypes.array,
  selectedValue: PropTypes.object
};

SingleFormSelect.defaultProps = {
  options: [{}],
  selectedValue: {}
};

export default SingleFormSelect;
